module.exports = __webpack_public_path__ + "prod/20250417163640/img/service.edbff227.png";